export type SkillRiskLevel = 'low' | 'medium' | 'high'

export type SkillStatus =
  | 'discovered'
  | 'pending-review'
  | 'installed'
  | 'suspended'

export type IconKey =
  | 'FileText' | 'FileType' | 'Headphones' | 'Camera' | 'Image' | 'Rows'
  | 'GitBranch' | 'Notebook' | 'Youtube' | 'Calendar' | 'Mail' | 'Globe'
  | 'Wand' | 'ScrollText' | 'Code2'

export interface SkillTool {
  name: string
  summary: string
  inputSchemaPreview: string
  sideEffects: {
    reads?: boolean
    writes?: boolean
    network?: boolean
    userFacing?: boolean
  }
  humanApprovalRequired: boolean
}

export interface SecurityDimension {
  key: string
  label: string
  rating: 'ok' | 'note' | 'warn'
  note?: string
}

export interface SecurityReview {
  verdict: 'clean' | 'suspicious' | 'malicious'
  confidence: 'high' | 'medium' | 'low'
  model: string
  dimensions: SecurityDimension[]
}

export interface AuditEntry {
  id: string
  tool: string
  invokedBy: string
  status: 'success' | 'failed' | 'rejected'
  approvedBy?: string
  durationMs: number
  timestamp: string
}

export interface SkillVersion {
  version: string
  approvedAt: string
}

export interface Skill {
  id: string
  slug: string
  name: string
  version: string
  domain: string
  description: string
  stars: number
  risk: SkillRiskLevel
  status: SkillStatus
  sha256: string
  author: string
  lastUsed?: string
  icon: IconKey
  tools: SkillTool[]
  securityReview?: SecurityReview
  contractYaml?: string
  audit?: AuditEntry[]
  versions?: SkillVersion[]
}

export const SKILL_RISK_COLOR: Record<SkillRiskLevel, string> = {
  low: '#4ac0d4',
  medium: '#e8a84c',
  high: '#e86c4c',
}
